// bao migrate skip
import * as ko from "knockout";
import * as moment from "moment";
import Bao from "./../services/bao-service";
// bao migrate - module not found: import Finito from "modules/finito-module";
import BaoMenu from "./../services/bao-menu";
import Guid from "./../factories/guid";
import baoRouter from "./../services/bao-router";
import BaoDialog from "./../factories/bao-dialog";
import finitoService from "./../services/finito-service";
import SubscriptionViewModel from "./../factories/subscription-view-model";
import appTabController from "./../services/app-tab-controller";
import InstructionAttachmentModel from "./../factories/instruction-attachment";
import InstructionHistoryViewModel from "./instruction-history";
import SendMailDialog from "./../factories/send-mail-dialog";
import InstructionShiftbookDialog from "./dialogs/instruction-shiftbook-dialog";

class InstructionViewModel extends SubscriptionViewModel {

    ReportId: KnockoutObservable<string>;
    InstructionId: KnockoutObservable<string>;
    InstructionPermissions: KnockoutObservable<any>;

    constructor(tabPage) {
        super(tabPage);
        var self: any = this;
        // SubscriptionViewModel.call(self, tabPage);
        self.CanMarkRead = ko.observable();
        self.IsClosed = ko.observable(false);
        self.AppTabController = appTabController;
        self.TextModuleField = ko.observable();
        self.ShowDueDate = ko.observable(true);
        self.InstructionTypeId = ko.observable();
        self.InstructionTypes = ko.observableArray();
        self.Priorities = ko.observableArray();
        self.Categories = ko.observableArray();
        self.SessionTabId = ko.observable();
        self.Instructionrecipients = ko.observableArray();
        self.AskIfReadAtClosing = true;
        self.ShowStatusDialog = ko.observable();
        self.FormName = ko.observable();
        self.ReportId = ko.observable();
        self.InstructionId = ko.observable();
        self.ShiftbookId = ko.observable();
        self.Revision = ko.observable();
        self.SelectedRecipients = ko.observableArray();
        self.EditRecipientsPermissionKey = "InstructionReportCustomToolbarRecipientsEdit";
        self.HasRecipientsEditPermission = Bao.Session.HasPermission(self.EditRecipientsPermissionKey, window.FinitoApplicationId);
        self.IsRecipientsListEditable = ko.observable(false);
        self.IsAutomaticReadWorkflowEnabled = ko.observable();
        self.IsNew = ko.observable();
        self.InstructionAttachment = ko.observableArray().extend({
            dirty: self.TabPage.DirtyFlag
        });
        self.SelectedTextModule = ko.observable();
        self.AreaId = ko.observable().extend({
            dirty: self.TabPage.DirtyFlag
        });
        self.AreaName = ko.observable().extend({
            dirty: self.TabPage.DirtyFlag
        });
        self.AreaEquipmentId = ko.observable().extend({
            dirty: self.TabPage.DirtyFlag
        });
        self.AreaEquipmentBinding = ko.observable().extend({
            dirty: self.TabPage.DirtyFlag
        });
        self.Device3NameBinding = ko.observable().extend({
            dirty: self.TabPage.DirtyFlag
        });
        self.Device3Id = ko.observable().extend({
            dirty: self.TabPage.DirtyFlag
        });
        self.Device4NameBinding = ko.observable().extend({
            dirty: self.TabPage.DirtyFlag
        });
        self.Device4Id = ko.observable().extend({
            dirty: self.TabPage.DirtyFlag
        });
        self.IgnoreDeviceChanges = ko.observable(true);
        self.ApproverUserId = ko.observable().extend({
            dirty: self.TabPage.DirtyFlag
        });
        self.ApproverUserFullName = ko.observable().extend({
            dirty: self.TabPage.DirtyFlag
        });
        self.ApprovalStateId = ko.observable();

        //user-tagging
        self.RawValue = ko.observable("");
        self.DisplayValue = ko.observable("");
        self.UserTaggingList = ko.observableArray();
        self.showUserTaggingControl = ko.observable(true);

        self.InfoId = ko.observable();
        self.SubTabsSaveFn = [];
        self.LinkItemToInfoFn = function () { };
        self.GetClosedDateFormatted = ko.pureComputed(function () {
            return moment(self.ClosedDateHtml(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
        });
        self.Device4Id.subscribe(function () {
            self.SetParentsByDevice4();
        });
        self.Device4NameBinding.subscribe(function () {
            if (!self.TabPage.IsLoading() && self.Device4Id() != null) {
                self.Device4Id(null);
            }
        });
        self.Device3Id.subscribe(function () {
            self.SetParentsByDevice3();
        });
        self.Device3NameBinding.subscribe(function () {
            if (!self.TabPage.IsLoading() && self.Device3Id() != null) {
                self.Device3Id(null);
            }
        });
        self.AreaEquipmentId.subscribe(function () {
            self.SetParentsByAreaEquipment();
        });
        self.AreaEquipmentBinding.subscribe(function () {
            if (!self.TabPage.IsLoading() && self.AreaEquipmentId() != null) {
                self.AreaEquipmentId(null);
            }
        });
        self.AreaId.subscribe(function () {
            self.SetChildrenByArea();
        });
        self.ApproverUserId.subscribe(function () {
            self.ApprovalStateId("4188cd62-7c56-433e-b7fd-a286590cd6fe");
        });
        self.showTextModuleDialog = function () { };
        self.openRecipientSearcher = function () { };
        self.showAttachmentDialog = function () { };
        self.uploadAttachment = function () { };
        self.Focus = function () { };
        self.ValidToMandatory = ko.pureComputed(function () {
            return self.InstructionTypeId() === finitoService.InstructionTypeIds.ValidFromTo || self.InstructionTypeId() === finitoService.InstructionTypeIds.ValidFromToOrFinished;
        });
        self.InstructionTypeId.subscribe(function (instructionTypeId) {
            self.ShowDueDate(!(instructionTypeId === finitoService.InstructionTypeIds.ValidToFinished));
            self.toggleButtons();
        });
        self.SelectedTextModule.subscribe(function (selectedTextModule) {
            finitoService.InsertAtCursorPositionContentEditable(self.TextModuleField().querySelector("#userTaggingInput"), selectedTextModule.Text);
        });
        self.subscribe(self.SelectedRecipients, function (selectedRecipients) {
            if (selectedRecipients && selectedRecipients.length > 0) {
                var recipients = ko.utils.arrayMap(selectedRecipients, function (srs: any) {
                    return {
                        UserId: srs.UserId,
                        RoleId: srs.RoleId,
                        ShiftbookId: srs.ShiftbookId ? srs.ShiftbookId : self.ShiftbookId(),
                        ShiftTypeId: srs.ShiftTypeId
                    };
                });
                if (recipients && recipients.length > 0) {
                    self.addRecipients(recipients);
                }
            }
        });
        self.IsNew.subscribe(() => {
            if (self.IsAutomaticReadWorkflowEnabled() && !self.IsRead.peek() && self.canRead()) {
                self.readInstruction(true, false);
            }
        });
        self.InstructionAttachment.Filtered = ko.pureComputed(function () {
            var instructionAttachment = self.InstructionAttachment(), revision = self.Revision();
            if (!isNaN(revision)) {
                return ko.utils.arrayFilter(instructionAttachment, function (att: any) {
                    return att.DeleteInRevision() === null || att.DeleteInRevision() > self.Revision();
                });
            }
            else {
                return instructionAttachment;
            }
        });
        self.getInstructionAttachments = function () {
            return Bao.post("Instruction/GetAttachments", JSON.stringify({
                sessionTabId: self.SessionTabId()
            })).done(function (data) { });
        };
        self.attachmentAdded = function () {
            self.TabPage.IsLoading(true);
            self.TabPage.DirtyFlag(true);
            self.getInstructionAttachments().done(function (data) {
                ko.map.fromJS(data, self.InstructionAttachment);
                self.TabPage.IsLoading(false);
            });
        };
        self.removeAttachment = function (attachment) {
            if (!self.IsHistory()) {
                self.TabPage.IsLoading(true);
                self.TabPage.DirtyFlag(true);
                attachment.DeleteInRevision(self.Revision());
                Bao.post("Instruction/RemoveAttachment", JSON.stringify({
                    sessionTabId: self.SessionTabId(),
                    attachmentId: attachment.InstructionAttachmentId(),
                    deleteInRevision: self.Revision()
                })).done(function () {
                    self.TabPage.IsLoading(false);
                });
            }
        };
        self.removeRecipient = function (recipient) {
            var def = $.Deferred();
            self.TabPage.IsLoading(true);
            self.TabPage.DirtyFlag(true);
            Bao.post("Instruction/RemoveRecipient", JSON.stringify({
                instructionRecipientId: ko.unwrap(recipient.InstructionRecipientId),
                sessionTabId: self.SessionTabId(),
                instructionId: self.InstructionId()
            }), function () {
                self.getRecipients().then(function () {
                    self.TabPage.IsLoading(false);
                    def.resolve();
                });
            });
            return def.promise();
        };
        self.removeAllRecipients = function () {
            var def = $.Deferred();
            self.TabPage.IsLoading(true);
            self.TabPage.DirtyFlag(true);
            Bao.post("Instruction/RemoveAllRecipients", JSON.stringify({
                instructionId: self.InstructionId(),
                sessionTabId: self.SessionTabId()
            }), function () {
                self.getRecipients().then(function () {
                    self.TabPage.IsLoading(false);
                    def.resolve();
                });
            });
            return def.promise();
        };
        self.init = function () {
            tabPage.IsLoading(true);
            self.LinkItemToInfoFn = tabPage.UrlData().linkFn;
            self.InstructionId(baoRouter.getRouteValue("id", self.TabPage));
            self.ShiftbookId(baoRouter.getRouteValue("shiftbookid", self.TabPage));
            var infoModel = tabPage.UrlData().InfoModel;
            if (infoModel != null) {
                self.InfoId(infoModel().InfoId());
                self.ShiftbookId(infoModel().ShiftbookId);
            }
            return $.when((function () {
                if (!self.InstructionId() && !ko.unwrap(self.ShiftbookId)) {
                    return self.ShiftbookPromptDialog();
                }
            })()).then(function () {
                return self.getFromServer();
            }).then(function (instructionServerModel) {
                if (ko.unwrap(instructionServerModel.ShiftbookId) == null && ko.unwrap(instructionServerModel.IsNew)) {
                    return self.ShiftbookPromptDialog().then(function () {
                        return instructionServerModel;
                    });
                }
                return instructionServerModel;
            }).then(function (instructionServerModel) {
                return self.InitInstruction(instructionServerModel);
            });
        };
        self.ShiftbookPromptDialog = function () {
            var shiftbookDialog = new InstructionShiftbookDialog(tabPage, "Instruction");
            var def = $.Deferred();
            shiftbookDialog.OpenDialog().then(function (result) {
                if (result != null) {
                    self.ShiftbookId(result.ShiftbookId);
                    def.resolve();
                }
                else {
                    self.AppTabController.RemoveTab(self.TabPage);
                    def.reject();
                }
            });
            return def;
        };
        self.InitInstruction = function (instructionModel) {
            self.TabPage.IsLoading(true);
            return $.when(self.getInstructionTypes(), self.getPriorities()).then(function () {
                return self.get(instructionModel);
            }).then(function () {
                return $.when(self.InitPermissionsByShiftbookId(), self.getCategories());
            });
        };
        self.InitPermissionsByShiftbookId = function () {
            return Bao.post("Shiftbook/GetPermissionsForShiftbook", JSON.stringify({
                shiftbookId: self.ShiftbookId()
            })).then(function (serverResult) {
                if (!serverResult)
                    return;
                self.InstructionPermissions = serverResult.RoleShiftbookPermissions;
            });
        };
        self.loaded = function () {
            var def = $.Deferred();
            self.ValidFromHtml.Formatted = ko.pureComputed(function () {
                if (self.ValidFromHtml()) {
                    return moment(self.ValidFromHtml(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
                }
                else {
                    return "";
                }
            });
            self.ValidToHtml.Formatted = ko.pureComputed(function () {
                if (self.ValidToHtml()) {
                    return moment(self.ValidToHtml(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeDisplayFormat);
                }
                else {
                    return "";
                }
            });
            self.registerMenuClick();
            self.toggleButtons();
            self.setTabTitle();
            self.refreshUserTagging();
            self.TabPage.IsLoading(false);
            self.Focus();
            self.IgnoreDeviceChanges(false);
            self.TabPage.DirtyFlag.reset();
            if (self.InfoId() != null) {
                self.TabPage.DirtyFlag(true);
            }
            self.AskIfReadAtClosing = self.AskIfMarkAsReadWhenClosingInstruction();
            def.resolve();
            return def.promise();
        };
        self.BeforeClose = function (fn) {
            if (self.TabPage.DirtyFlag() && self.SaveAllowed() && !self.IsHistory() && !self.IsClosed()) {
                self.shouldSave().then(function (shouldSave) {
                    if (shouldSave === true) {
                        self.validate().then(function (isValid) {
                            if (isValid) {
                                self.Save().then(function () {
                                    self.clearSession().then(function () {
                                        fn();
                                    });
                                });
                            }
                            else {
                                self.showValidationErrors();
                            }
                        });
                    }
                    else if (shouldSave === false) {
                        self.clearSession().then(function () {
                            fn();
                        });
                    }
                    else { }
                });
            }
            else {
                if (self.AskIfReadAtClosing && self.canRead()) {
                    self.readInstructionQuestionDialog().then(function (userMarksAsRead) {
                        if (userMarksAsRead === true) {
                            self.readInstruction(true, true).then(function () {
                                self.clearSession().then(function () {
                                    fn();
                                });
                            });
                        }
                        else if (userMarksAsRead === false) {
                            self.clearSession().then(function () {
                                fn();
                            });
                        }
                        else { }
                    });
                }
                else {
                    self.clearSession().then(function () {
                        fn();
                    });
                }
            }
        };
        self.SetPermissions = function (showBtnsFn) {
            var permissions = self.InstructionPermissions;
            if (!permissions)
                return;
            self.IsRecipientsListEditable(permissions[self.EditRecipientsPermissionKey] && self.HasRecipientsEditPermission());
            for (var actionKey in permissions) {
                if (self.boaToolbar2ShowButton) {
                    self.boaToolbar2ShowButton(actionKey, permissions[actionKey]);
                }
                if (showBtnsFn) {
                    showBtnsFn(actionKey, permissions[actionKey]);
                }
                BaoMenu.permissionVisible({
                    ActionKey: actionKey,
                    Context: self.TabPage.Context(),
                    Visible: permissions[actionKey]
                });
            }
        }
    }

    readInstructionQuestionDialog = function () {
        var deferred = $.Deferred();
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgInstructionReadCheck"), "question");
        dialog.DialogResult.subscribe(function (markAsRead) {
            deferred.resolve(markAsRead);
        });
        return deferred.promise();
    };
    registerMenuClick = function () {
        var self = this;
        BaoMenu.registerEvent(function (btn) {
            if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
                switch (btn.ActionKey()) {
                    case "InstructionNew":
                        self["new"]();
                        break;
                    case "InstructionSave":
                        if (self.TabPage.DirtyFlag() && self.SaveAllowed() && !self.IsHistory()) {
                            self.validate().then(function (isValid) {
                                if (isValid) {
                                    self.Save();
                                }
                                else {
                                    self.showValidationErrors();
                                }
                            });
                        }
                        break;
                    case "InstructionDelete":
                        self["delete"]();
                        break;
                    case "InstructionFinish":
                        self.finish();
                        break;
                    case "InstructionRead":
                        self.read();
                        break;
                    case "InstructionHistory":
                        self.history();
                        break;
                    case "InstructionSendMail":
                        var description = "";
                        for (var i = 0; i < self.InstructionTypes().length; i++) {
                            if (self.InstructionTypeId() == self.InstructionTypes()[i].InstructionTypeId()) {
                                description = self.InstructionTypes()[i].Description();
                            }
                        }
                        self.SendReportMail(self, self.InstructionId());
                        break;
                    case "InstructionPrint":
                        self.InstructionPrint(self, self.InstructionId());
                        break;
                    case "InstructionApprove":
                        self.approvalDialog();
                        break;
                }
            }
        });
    };
    SendReportMail = function (self, modelId) {
        self.TabPage.IsLoading(true);
        var dialog = new SendMailDialog(this, modelId, null);
        dialog.DialogInstruction();
    };
    InstructionPrint = function (self, modelId) {
        self.TabPage.IsLoading(true);
        Bao.post("Instruction/Print", JSON.stringify({
            modelId: modelId
        }), function (result) {
            self.TabPage.IsLoading(false);
            if (result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            }
            else {
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    };
    canClose = function () {
        var self = this, result = $.Deferred();
        if (self.IsHistory()) {
            result.resolve(true);
        }
        else {
            if (self.TabPage.DirtyFlag() && self.SaveAllowed()) {
                result.resolve(false);
            }
            else {
                result.resolve(true);
            }
        }
        return result.promise();
    };
    shouldSave = function () {
        var deferred = $.Deferred();
        if (this.InstructionPermissions?.InstructionSave) {
            var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.SaveCheck), "question");
            dialog.DialogResult.subscribe(function (saveInstruction) {
                deferred.resolve(saveInstruction);
            });
        }
        else {
            deferred.resolve(false);
        }
        return deferred.promise();
    };
    validate = function () {
        return this.CompleteCheck();
    };
    CompleteCheck = function () {
        var self = this;
        return Bao.post("Instruction/Validate", JSON.stringify({
            instructionModel: ko.map.toJS(self, true)
        }));
    };
    toggleButtons = function () {
        var self = this;
        if (self.IsHistory && self.IsClosed && self.IsNew) {
            var canSave = !self.IsHistory() && self.SaveAllowed() && !self.IsClosed.peek();
            BaoMenu.permissionEnable({
                ActionKey: "InstructionSave",
                Enabled: canSave,
                Context: self.TabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "InstructionDelete",
                Enabled: !self.IsHistory() && !self.IsClosed.peek() && !self.IsNew() && !self.IsPublished.peek(),
                Context: self.TabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "InstructionFinish",
                Enabled: self.canFinish(),
                Context: self.TabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "InstructionRead",
                Enabled: self.canRead(),
                Context: self.TabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "InstructionHistory",
                Enabled: self.HasHistory() && !self.IsNew(),
                Context: self.TabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "InstructionSendMail",
                Enabled: !self.IsNew(),
                Context: self.TabPage.Context()
            });
            BaoMenu.permissionEnable({
                ActionKey: "InstructionApprove",
                Enabled: self.canApprove(),
                Context: self.TabPage.Context()
            });
        }
    };
    setTabTitle = function () {
        var self = this;
        self.TabPage.Title(self.TabName());
    };
    getInstructionTypes = function () {
        var self = this;
        return Bao.post("Instruction/GetInstructionTypes", JSON.stringify({})).then(function (result) {
            ko.map.fromJS(result, self.InstructionTypes);
        });
    };
    getPriorities = function () {
        var self = this;
        return Bao.post("Instruction/GetPriorities", JSON.stringify({})).then(function (result) {
            ko.map.fromJS(result, self.Priorities);
        });
    };
    getCategories = function () {
        var self = this;
        return Bao.post("Instruction/GetCategories", JSON.stringify({
            shiftbookId: self.ShiftbookId()
        })).then(function (result) {
            ko.map.fromJS(result, self.Categories);
        });
    };
    getFromServer = function () {
        var self = this;
        return self.clearSession().then(function () {
            return Bao.post("Instruction/Get", JSON.stringify({
                instructionId: self.InstructionId(),
                shiftbookId: self.ShiftbookId(),
                infoId: self.InfoId(),
                contextShiftbookId: baoRouter.getRouteValue("contextShiftbookId", self.TabPage),
                contextShiftTypeId: baoRouter.getRouteValue("contextShiftType", self.TabPage)
            }));
        });
    };
    get = function (servermodel) {
        var self = this;
        if (!servermodel) {
            servermodel = self.getFromServer();
        }
        return $.when(servermodel).then(function (result) {
            ko.map.fromJS(result, self, self.TabPage.DirtyFlag);
            if (result.IsNew) {
                self.TabPage.ObjectId(result.InstructionId);
            }
            return self.getRecipients();
        }).then(function () {
            self.TabPage.DirtyFlag.reset();
        });
        ;
    };
    clearSession = function () {
        var self = this;
        let sessionKeyRecipients = 'recipients'+ self.InstructionId()
        return Bao.post("Instruction/ClearSession", JSON.stringify({
            sessionTabId: this.SessionTabId(),
            sessionKeyRecipients: sessionKeyRecipients
        }));
    };
    getRecipients = function () {
        var self = this;
        return Bao.post("Instruction/GetRecipients", JSON.stringify({
            instructionId: self.InstructionId(),
            sessionTabId: self.SessionTabId(),
            revision: self.Revision()
        }), function (result) {
            self.Instructionrecipients(result);
        });
    };
    addRecipients = function (recipients) {
        var self = this;
        var def = $.Deferred();
        self.TabPage.IsLoading(true);
        self.TabPage.DirtyFlag(true);
        Bao.post("Instruction/AddRecipients", JSON.stringify({
            instructionId: self.InstructionId(),
            revision: self.Revision(),
            recipients: recipients,
            sessionTabId: self.SessionTabId()
        }), function () {
            self.getRecipients().then(function () {
                self.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    };
    ["new"] = function () {
        var linkHash = "instruction/" + Guid();
        baoRouter.setHash(linkHash);
    };
    Save = function () {
        var self = this;
        var def = $.Deferred();
        if (self.TabPage.DirtyFlag()) {
            var instructionModel = ko.map.toJS(self, true);
            instructionModel.InstructionAttachment = ko.map.toJS(self.InstructionAttachment);
            self.TabPage.IsLoading(true);
            Bao.post("Instruction/Save", JSON.stringify({
                instructionModel: instructionModel
            })).then(function (saved) {
                if (saved) {
                    var defs = [];
                    if (typeof self.SubTabsSaveFn !== "undefined" && self.SubTabsSaveFn != false) {
                        ko.utils.arrayForEach(self.SubTabsSaveFn, function (saveFn) {
                            if (typeof saveFn === "function") {
                                defs.push(saveFn());
                            }
                        });
                    }
                    var subTasksDeferreds = $.when.apply(this, defs);
                    self.showAlert(finitoService.MessageKeys.InstructionSaveSuccessful);
                    if (typeof self.LinkItemToInfoFn === "function") {
                        self.LinkItemToInfoFn(ko.unwrap(self.InstructionId));
                    }
                    self.TabPage.DirtyFlag(false);
                    self.get().then(function () {
                        self.TabPage.IsLoading(false);
                        self.TabPage.ObjectId(self.InstructionId());
                        self.updateHash(self.InstructionId());
                        self.toggleButtons();
                        self.setTabTitle();
                        subTasksDeferreds.done(function () {
                            def.resolve();
                        }).always(function () {
                            self.TabPage.DirtyFlag(false);
                        });
                    });
                }
                else {
                    self.showAlert(finitoService.MessageKeys.InstructionSaveError, "info");
                    self.TabPage.IsLoading(false);
                    self.setTabTitle();
                    subTasksDeferreds.done(function () {
                        def.resolve();
                    });
                }
                Bao.raiseEvent('user-tagging:save', { entityId: self.InstructionId() });
                Bao.raiseEvent("instructions:refresh", {});
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    updateHash = function (instructionId) {
        var currentInstructionId = baoRouter.getRouteValue("id", this.TabPage);
        if (currentInstructionId) {
            var newHash = baoRouter.getHash().replace(currentInstructionId, instructionId);
            if (newHash) {
                baoRouter.setHash(newHash);
            }
        }
    };
    finish = function () {
        var self = this;
        self.canClose().then(function (canClose) {
            if (canClose) {
                self.finishInstruction();
            }
            else {
                self.shouldSave().then(function (shouldSave) {
                    if (shouldSave === true) {
                        self.save().then(function () {
                            self.finishInstruction();
                            self.toggleButtons();
                        });
                    }
                    else if (shouldSave === false) {
                        self.finishInstruction();
                        self.toggleButtons();
                    }
                    else { }
                });
            }
        });
    };
    finishInstruction = function () {
        var self = this;
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InstructionFinishQuestion), "yesno");
        dialog.DialogResult.subscribe(function (shouldFinish) {
            if (shouldFinish) {
                self.TabPage.IsLoading(true);
                Bao.post("Instruction/Finish", JSON.stringify({
                    instructionIds: [self.InstructionId()]
                })).then(function (finished) {
                    self.TabPage.IsLoading(false);
                    if (finished > 0) {
                        self.showAlert(finitoService.MessageKeys.InstructionFinishSuccessful);
                        self.TabPage.DirtyFlag(false);
                        self.dispose();
                        self.AppTabController.RemoveTab(self.TabPage);
                        Bao.raiseEvent("instructions:refresh", {});
                    }
                    else {
                        self.showAlert(finitoService.MessageKeys.InstructionFinishError, "info");
                    }
                });
            }
        });
    };
    canFinish = function () {
        if (!this.IsClosed.peek() && !this.IsHistory.peek() && !this.IsNew.peek() && this.CanEditBasedOnApproval.peek()) {
            if (this.InstructionTypeId.peek() === finitoService.InstructionTypeIds.ValidToFinished || this.InstructionTypeId.peek() === finitoService.InstructionTypeIds.ValidFromToOrFinished) {
                return true;
            }
        }
        return false;
    };
    canApprove = function () {
        if (!this.IsClosed.peek() && !this.IsHistory.peek() && !this.IsNew.peek()) {
            if (this.IsApprover.peek() && this.IsWaitForApproval.peek()) {
                return true;
            }
        }
        return false;
    };
    approvalDialog = function () {
        var self = this;
        return Bao.post("Instruction/InstructionApprovalDialog", JSON.stringify({}), function (result) {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.ViewModel(self);
            var approveButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgApprove"), function () {
                self.TabPage.IsLoading(true);
                Bao.post("Instruction/Approve", JSON.stringify({
                    instructionId: self.InstructionId()
                })).then(function (approved) {
                    self.TabPage.IsLoading(false);
                    if (approved > 0) {
                        self.showAlert(finitoService.MessageKeys.InstructionApproveSuccessful);
                        self.get().then(function () {
                            self.TabPage.IsLoading(false);
                            self.toggleButtons();
                            self.TabPage.DirtyFlag(false);
                        });
                    }
                    else {
                        self.showAlert(finitoService.MessageKeys.InstructionApproveError, "info");
                    }
                });
                dialog.Close();
            });
            var rejectButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgReject"), function () {
                self.TabPage.IsLoading(true);
                Bao.post("Instruction/Reject", JSON.stringify({
                    instructionId: self.InstructionId()
                })).then(function (rejected) {
                    self.TabPage.IsLoading(false);
                    if (rejected > 0) {
                        self.showAlert(finitoService.MessageKeys.InstructionRejectSuccessful);
                        self.get().then(function () {
                            self.TabPage.IsLoading(false);
                            self.toggleButtons();
                            self.TabPage.DirtyFlag(false);
                        });
                    }
                    else {
                        self.showAlert(finitoService.MessageKeys.InstructionRejectError, "info");
                    }
                });
                dialog.Close();
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), function () {
                dialog.Close();
            });
            dialog.Buttons([approveButton, rejectButton, cancelButton]);
            dialog.Template(result.Template);
            dialog.Open();
        });
    };
    read = function () {
        var self = this;
        self.canClose().then(function (canClose) {
            if (canClose) {
                self.readInstructionYesNoDialog();
            }
            else {
                self.shouldSave().then(function (shouldSave) {
                    if (shouldSave === true) {
                        self.save().then(function () {
                            self.readInstructionYesNoDialog();
                        });
                    }
                    else if (shouldSave === false) {
                        self.readInstructionYesNoDialog();
                    }
                });
            }
        });
    };
    GetOrgUnitIdFromReferrer = function () {
        var orgUnitId = baoRouter.getRouteValue("orgunitId", this.TabPage);
        return orgUnitId;
    };
    readInstructionYesNoDialog = function () {
        var self = this;
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InstructionReadQuestion), "yesno");
        dialog.DialogResult.subscribe(function (shouldRead) {
            self.readInstruction(shouldRead, true);
        });
    };
    readInstruction = function (shouldRead, shouldRemoveTab) {
        var self = this;
        var deferred = $.Deferred();
        if (shouldRead) {
            self.TabPage.IsLoading(true);
            var read = 1;
            Bao.post("Instruction/Read", JSON.stringify({
                instructionIds: [self.InstructionId()],
                contextShiftbookId: baoRouter.getRouteValue("contextShiftbookId", self.TabPage),
                contextShiftTypeId: baoRouter.getRouteValue("contextShiftType", self.TabPage)
            })).then(function (read) {
                self.TabPage.IsLoading(false);
                if (read > 0) {
                    self.showAlert(finitoService.MessageKeys.InstructionReadSuccessful);
                    self.TabPage.DirtyFlag(false);
                    self.dispose();
                    self.AskIfReadAtClosing = false;
                    if (shouldRemoveTab) {
                        self.AppTabController.RemoveTab(self.TabPage);
                    }
                    self.IsRead(true);
                    Bao.raiseEvent("instructions:refresh", {});
                }
                else {
                    self.showAlert(finitoService.MessageKeys.InstructionReadError, "info");
                }
            });
        }
        return deferred.promise();
    };
    canRead = function () {
        return $.isFunction(this.IsHistory) &&
            !this.IsHistory.peek() &&
            !this.IsClosed.peek() &&
            !(typeof this.IsNew === "function" && this.IsNew()) &&
            this.CanMarkRead() &&
            !this.IsRead.peek() &&
            this.IsInstructionValid() &&
            this.CanEditBasedOnApproval.peek();
    };

    ["delete"] = function () {
        var self = this;
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InstructionDeleteQuestion), "yesno");
        dialog.DialogResult.subscribe(function (canDelete) {
            if (canDelete) {
                self.TabPage.IsLoading(true);
                return Bao.post("Instruction/Delete", JSON.stringify({
                    instructionIds: [self.InstructionId()]
                })).then(function (deleted) {
                    if (deleted > 0) {
                        self.showAlert(finitoService.MessageKeys.InstructionDeleteSuccessful);
                        self.TabPage.DirtyFlag(false);
                        self.dispose();
                        self.AppTabController.RemoveTab(self.TabPage);
                        Bao.raiseEvent("instructions:refresh", {});
                    }
                    else {
                        self.showAlert(finitoService.MessageKeys.InstructionDeleteError, "info");
                    }
                    self.TabPage.IsLoading(false);
                });
            }
        });
    };
    forward = function () { };
    backward = function () { };
    getIdsFromRecipientString = function (recipientString) {
        var result = [];
        var rsArray = recipientString.split("|");
        if (rsArray && rsArray.length > 0) {
            result[0] = rsArray[0] ? rsArray[0] : null;
            result[1] = rsArray[1] ? rsArray[1] : null;
            result[2] = rsArray[2] ? rsArray[2] : null;
        }
        return result;
    };
    getHistory = function (historyItem) {
        var self = this;
            self.TabPage.IsLoading(true);
            self.TabPage.DirtyFlag(false);
            if (historyItem) {
                if (historyItem.IsNewestRevision()) {
                    self.get().then(function () {
                        Bao.raiseEvent('linked-item:refreshToolbarButton', null);
                        if (self.TextModuleField() != undefined ) {

                            finitoService.setTextToUserTaggingInput(self.TextModuleField().querySelector("#userTaggingInput"), historyItem.InstructionText(), false)
                        }
                        self.toggleButtons();
                        self.setTabTitle();
                        self.TabPage.IsLoading(false);
                    });
                }
                else {
                    self.clearSession().then(function () {
                        Bao.post("Instruction/GetHistory", JSON.stringify({
                            instructionHistoryId: historyItem.InstructionHistoryId()
                        })).then(function (result) {
                            ko.map.fromJS(result, self, self.TabPage.DirtyFlag);
                            Bao.raiseEvent('linked-item:refreshToolbarButton', null);
                            if (self.TextModuleField()!= undefined && result != undefined) {

                                finitoService.setTextToUserTaggingInput(self.TextModuleField().querySelector("#userTaggingInput"), result.InstructionText, result.IsHistory)
                            }
                            self.getRecipients().then(function () {
                                self.toggleButtons();
                                self.setTabTitle();
                                self.TabPage.IsLoading(false);
                            });
                        });
                    });
                }
            }
    };
    history = function () {
        var self = this;
        Bao.get("Instruction/History", $.param({
            instructionId: self.InstructionId()
        })).then(function (html) {
            var dialog = new BaoDialog(Bao.Session.GetMessage("msgHistory"));
            dialog.ViewModel(new InstructionHistoryViewModel(self.InstructionId(), function (historyItem) {
                self.getHistory(historyItem);
                dialog.Close();
            }));
            dialog.Template(html);
            dialog.Buttons([{
                Title: Bao.Session.GetMessage("msgOk"),
                Click: function () {
                    if (dialog.ViewModel().Selection()) {
                        self.getHistory(dialog.ViewModel().Selection()[0]);
                    }
                    dialog.Close();
                },
                Enabled: dialog.ViewModel().HasSelection
            }, {
                Title: Bao.Session.GetMessage("msgCancel"),
                Click: function () {
                    dialog.Close();
                },
                Enabled: ko.observable(true)
            }]);
            dialog.ViewModel().initialize();
            dialog.Open();
        });
    };
    SetParentsByDevice4 = function () {
        var self = this;
        var def = $.Deferred();
        if (self.IgnoreDeviceChanges() == false) {
            if (self.Device4Id() != null) {
                self.TabPage.IsLoading(true);
                self.IgnoreDeviceChanges(true);
                Bao.post("Device/Device4Parents", JSON.stringify({
                    device4Id: self.Device4Id()
                }), function (result) {
                    if (result != null) {
                        if (result.Device3Id != null && self.Device3Id() == null && Bao.Utils.String.IsNullOrWhitespace(self.Device3NameBinding())) {
                            self.Device3Id(result.Device3Id);
                            self.Device3NameBinding(result.Device3Name);
                        }
                        if (result.AreaEquipmentId != null && self.AreaEquipmentId() == null && Bao.Utils.String.IsNullOrWhitespace(self.AreaEquipmentBinding())) {
                            self.AreaEquipmentId(result.AreaEquipmentId);
                            self.AreaEquipmentBinding(result.AreaEquipmentName);
                        }
                        if (result.AreaId != null && self.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(self.AreaName())) {
                            self.AreaId(result.AreaId);
                            self.AreaName(result.AreaName);
                        }
                    }
                }).always(function () {
                    self.TabPage.IsLoading(false);
                    self.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    SetParentsByDevice3 = function () {
        var self = this;
        var def = $.Deferred();
        if (self.IgnoreDeviceChanges() == false) {
            self.IgnoreDeviceChanges(true);
            if (self.Device3Id() != null) {
                self.TabPage.IsLoading(true);
                $.when(Bao.post("Device/Device3Parents", JSON.stringify({
                    device3Id: self.Device3Id()
                }), function (result) {
                    if (result != null) {
                        if (result.AreaEquipmentId != null && self.AreaEquipmentId() == null && Bao.Utils.String.IsNullOrWhitespace(self.AreaEquipmentBinding())) {
                            self.AreaEquipmentId(result.AreaEquipmentId);
                            self.AreaEquipmentBinding(result.AreaEquipmentName);
                        }
                        if (result.AreaId != null && self.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(self.AreaName())) {
                            self.AreaId(result.AreaId);
                            self.AreaName(result.AreaName);
                        }
                    }
                }), Bao.post("Device/Device3Children", JSON.stringify({
                    device3Id: self.Device3Id(),
                    device4Id: self.Device4Id()
                }), function (result) {
                    if (result != null) {
                        if (result.Device4 == false) {
                            self.Device4Id(null);
                            self.Device4NameBinding(null);
                        }
                    }
                })).always(function () {
                    self.TabPage.IsLoading(false);
                    self.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                self.Device4Id(null);
                self.Device4NameBinding(null);
                self.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    SetParentsByAreaEquipment = function () {
        var self = this;
        var def = $.Deferred();
        if (self.IgnoreDeviceChanges() == false) {
            self.IgnoreDeviceChanges(true);
            if (self.AreaEquipmentId() != null) {
                self.TabPage.IsLoading(true);
                $.when(Bao.post("Device/AreaEqupimentParents", JSON.stringify({
                    areaEquipmentId: self.AreaEquipmentId()
                }), function (result) {
                    if (result != null) {
                        if (result.AreaId != null && self.AreaId() == null && Bao.Utils.String.IsNullOrWhitespace(self.AreaName())) {
                            self.AreaId(result.AreaId);
                            self.AreaName(result.AreaName);
                        }
                    }
                }), Bao.post("Device/AreaEquipmentChildren", JSON.stringify({
                    areaEquipmentId: self.AreaEquipmentId(),
                    device3Id: self.Device3Id(),
                    device4Id: self.Device4Id()
                }), function (result) {
                    if (result != null) {
                        if (result.Device3 == false) {
                            self.Device3Id(null);
                            self.Device3NameBinding(null);
                        }
                        if (result.Device4 == false) {
                            self.Device4Id(null);
                            self.Device4NameBinding(null);
                        }
                    }
                })).always(function () {
                    self.TabPage.IsLoading(false);
                    self.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                self.Device3Id(null);
                self.Device3NameBinding(null);
                self.Device4Id(null);
                self.Device4NameBinding(null);
                self.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    SetChildrenByArea = function () {
        var self = this;
        var def = $.Deferred();
        if (self.IgnoreDeviceChanges() == false) {
            self.IgnoreDeviceChanges(true);
            if (self.AreaId() != null) {
                self.TabPage.IsLoading(true);
                Bao.post("Device/AreaChildren", JSON.stringify({
                    areaId: self.AreaId(),
                    areaEquipmentId: self.AreaEquipmentId(),
                    device3Id: self.Device3Id(),
                    device4Id: self.Device4Id()
                }), function (result) {
                    if (result != null) {
                        if (result.AreaEquipment == false) {
                            self.AreaEquipmentId(null);
                            self.AreaEquipmentBinding(null);
                        }
                        if (result.Device3 == false) {
                            self.Device3Id(null);
                            self.Device3NameBinding(null);
                        }
                        if (result.Device4 == false) {
                            self.Device4Id(null);
                            self.Device4NameBinding(null);
                        }
                    }
                }).always(function () {
                    self.TabPage.IsLoading(false);
                    self.IgnoreDeviceChanges(false);
                    def.resolve();
                });
            }
            else {
                self.AreaEquipmentBinding(null);
                self.AreaEquipmentId(null);
                self.Device3Id(null);
                self.Device3NameBinding(null);
                self.Device4Id(null);
                self.Device4NameBinding(null);
                self.IgnoreDeviceChanges(false);
                def.resolve();
            }
        }
        return def.promise();
    };
    refreshUserTagging = function () {
        var self = this;
        self.showUserTaggingControl(false);
        self.showUserTaggingControl(true);
    }
}
export default InstructionViewModel;